import React from "react";

function AppAnalytics({ details }) {
  return (
    <div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Item name="Total Transacted" value={details?.totalTransacted} />
        <Item name="All Links" value={details?.allLinks} />
        {/* <Item name="Total" value="20,000" />
        <Item name="Total" value="20,000" /> */}
      </div>
    </div>
  );
}

function Item({ value, name }) {
  return (
    <div className="p-4 bg-yellow-200 opacity-80 rounded-xl text-gray-800">
      <div className="font-bold text-2xl leading-none">{value}</div>
      <div className="mt-2">{name}</div>
    </div>
  );
}

export default AppAnalytics;
